import { useLocationWeatherContext } from "../contexts/LocationWeatherContext";
import { getDateOnlyString, } from "../helpers/weather-helpers";
import { DAY_NIGHT_TEXT_COLOR } from "../types/Weather";
import TodayWeatherAlertsSection from "./TodayWeatherAlertsSection";
import TodayWeatherMainSection from "./TodayWeatherMainSection";
import WeatherCurrentDetailsSection from "./WeatherCurrentDetailsSection";
import WeatherPrecipatationSection from "./WeatherPrecipatationSection";
import { Box, Paper } from "@mui/material";


const TodayWeather = () => {

  const {
    currentWeather,
    hourlyWeatherUnit,
    hourlyWeatherMap,
    dailyWeatherMap,
    dailyWeatherUnit,
    currentAirQualityIndex,
    isLoading
  } = useLocationWeatherContext();

  const todayDateStr = getDateOnlyString(currentWeather?.time)
  if (!todayDateStr) {
    return <></>;
  }

  const todayHourlyWeather = hourlyWeatherMap.get(todayDateStr);
  const todayDailyWeather = dailyWeatherMap.get(todayDateStr);
  if (!todayHourlyWeather || !todayDailyWeather || !currentWeather || !hourlyWeatherUnit || !dailyWeatherUnit) {
    return <></>;
  }

  return (
    <Box >
      <TodayWeatherMainSection
        currentWeather={currentWeather}
        todayHourlyWeather={todayHourlyWeather}
        hourlyWeatherUnit={hourlyWeatherUnit} />
      <TodayWeatherAlertsSection />
      <Paper sx={{
        borderRadius: '16px',
        marginTop: 2,
        paddingY: 0.005,
        paddingX: 2,
        backgroundColor: DAY_NIGHT_TEXT_COLOR,
        opacity: 0.85,
      }}>
        <WeatherCurrentDetailsSection
          dailyWeather={todayDailyWeather}
          dailyWeatherUnit={dailyWeatherUnit}
          hourlyWeather={todayHourlyWeather}
          hourlyWeatherUnit={hourlyWeatherUnit}
          currentWindSpeed={currentWeather.windspeed}
          currentWindDirection={currentWeather.winddirection}
          currentAirQualityIndex={currentAirQualityIndex}
          headerText="Current details" />
      </Paper>
      <Paper sx={{
        borderRadius: '16px',
        marginTop: 2,
        paddingY: 0.005,
        paddingX: 2,
        backgroundColor: DAY_NIGHT_TEXT_COLOR,
        opacity: 0.85,
      }}>
        <WeatherPrecipatationSection
          hourlyWeather={todayHourlyWeather}
          hourlyWeatherUnit={hourlyWeatherUnit} />
      </Paper>
    </Box>
  );
}

export default TodayWeather;